"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _order = require("@/types/order");
var _enum = require("@/utils/enum");
var _moment = _interopRequireDefault(require("moment"));
var _vuePropertyDecorator = require("vue-property-decorator");
var OrderTable = /*#__PURE__*/function (_Vue) {
  function OrderTable() {
    var _this;
    (0, _classCallCheck2.default)(this, OrderTable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, OrderTable, [].concat(args));
    (0, _defineProperty2.default)(_this, "data", void 0);
    (0, _defineProperty2.default)(_this, "loading", void 0);
    (0, _defineProperty2.default)(_this, "query", void 0);
    (0, _defineProperty2.default)(_this, "total", void 0);
    (0, _defineProperty2.default)(_this, "type", void 0);
    (0, _defineProperty2.default)(_this, "onClickRow", void 0);
    (0, _defineProperty2.default)(_this, "onClickAction", void 0);
    (0, _defineProperty2.default)(_this, "tagOptions", _enum.tagOptions);
    (0, _defineProperty2.default)(_this, "preventRowClick", false);
    (0, _defineProperty2.default)(_this, "OrderType", _order.OrderType);
    return _this;
  }
  (0, _inherits2.default)(OrderTable, _Vue);
  return (0, _createClass2.default)(OrderTable, [{
    key: "formatDateDuration",
    value: function formatDateDuration(date) {
      var dateLeft = _moment.default.duration(date, "seconds").humanize(true);
      return dateLeft.replace("in", "next");
    }
  }, {
    key: "onClickHandle",
    value: function onClickHandle(row) {
      this.$emit("update", row);
    }
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], OrderTable.prototype, "data", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], OrderTable.prototype, "loading", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Object,
  default: function _default() {
    return {
      limit: 10,
      page: 1
    };
  }
})], OrderTable.prototype, "query", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], OrderTable.prototype, "total", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: "order"
})], OrderTable.prototype, "type", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], OrderTable.prototype, "onClickRow", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], OrderTable.prototype, "onClickAction", void 0);
OrderTable = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], OrderTable);
var _default2 = exports.default = OrderTable;